import * as React from 'react';

import FileCanvas16 from './FileCanvas16';

export const fileCanvas16 = () => <FileCanvas16 />;

export default {
    title: 'Icon/Fill/FileCanvas16',
    component: FileCanvas16,
    parameters: {
        notes: "`import FileCanvas16 from 'box-ui-elements/es/icon/fill/FileCanvas16';`",
    },
};
